import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveSession } from '@core/models/dashboard.model';
import { TranslocoService } from '@ngneat/transloco';
import { createQuery, IQuery, Refreshable } from '@utils';
import { Action, Column, createAction, createColumn, EnhancedTable } from 'src/app/modules/enhanced-table';

import { DashboardService } from '../../dashboard.service';
import it from './i18n/active-sessions.it.json';

@Component({
  selector: 'app-active-sessions',
  templateUrl: './active-sessions.component.html'
})
export class ActiveSessionsComponent implements Refreshable {

  @ViewChild('table') table!: EnhancedTable<ActiveSession>;

  sourceFn = (query: IQuery) => this.dashboardSvc.getActiveSessions(query);
  columns: Column<ActiveSession>[];
  actions: Action<ActiveSession>[];

  constructor(
    private dashboardSvc: DashboardService,
    private translocoSvc: TranslocoService,
    private router: Router
  ) {
    this.translocoSvc.setTranslation(it, 'it');

    this.columns = [
      createColumn({ label: this.translocoSvc.translate('activeSessions.fields.createdOn'), field: 'createdOn', type: 'utcDatetime' }),
      createColumn({ label: this.translocoSvc.translate('activeSessions.fields.userFullname'), field: 'userFullname' }),
      createColumn({ label: this.translocoSvc.translate('activeSessions.fields.mainProcedureCategory'), field: 'mainProcedureCategory' }),
      createColumn({ label: this.translocoSvc.translate('activeSessions.fields.mainProcedureName'), field: 'mainProcedureName' }),
      createColumn({ label: this.translocoSvc.translate('activeSessions.fields.currentStep'), field: 'currentStep' }),
      createColumn({
        label: this.translocoSvc.translate('activeSessions.fields.currentStepType'), field: 'currentStepType', type: 'custom',
        render: (data) => data.currentStepType ? this.translocoSvc.translate('procedure-step-type.' + data.currentStepType) : ''
      }),
      createColumn({ label: this.translocoSvc.translate('activeSessions.fields.isBlocking'), field: 'isBlocking', type: 'boolean' })
    ];
    this.actions = [
      createAction({
        icon: 'launch',
        fn: session => this.router.navigateByUrl(`/app/report/workflow/${session.workflowId}/session/${session.id}`),
        label: this.translocoSvc.translate('buttons.open')
      })
    ];
  }

  refresh() {
    this.table.fetch(createQuery({ index: 0 }));
  }

}
